/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChooseAuthenticatorRequest } from '../models/ChooseAuthenticatorRequest';
import type { GetAlternativesResponse } from '../models/GetAlternativesResponse';
import type { MfaFlowResponse } from '../models/MfaFlowResponse';
import type { ResendAvailability } from '../models/ResendAvailability';
import type { StartMFARequest } from '../models/StartMFARequest';
import type { SubmitResponseRequest } from '../models/SubmitResponseRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MfaOrchestratorService {
    /**
     * Start MFA Flow from Authenticated Session
     * Start a new MFA flow using an authenticated session cookie
     * @param requestBody
     * @param mfaAuthenticatedSession
     * @param pendingAuthSession
     * @param hostDbscSession
     * @returns any Probe / FAILED-without-error_info (no session created)
     * @returns MfaFlowResponse Successful Response
     * @throws ApiError
     */
    public static startMfaFlowFromCookie(
        requestBody: StartMFARequest,
        mfaAuthenticatedSession?: (string | null),
        pendingAuthSession?: (string | null),
        hostDbscSession?: (string | null),
    ): CancelablePromise<any | MfaFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/orchestrator/start-from-cookie',
            cookies: {
                'mfa_authenticated_session': mfaAuthenticatedSession,
                'pending_auth_session': pendingAuthSession,
                '__Host-dbsc_session': hostDbscSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid pending auth session or flow state`,
                401: `Authentication / MFA session expired`,
                403: `User account disabled or flow forbidden`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Start MFA Flow
     * Start a new MFA flow and set session cookie
     * @param requestBody
     * @param pendingAuthSession
     * @param hostDbscSession
     * @returns any Probe / FAILED-without-error_info (no session created)
     * @returns MfaFlowResponse Successful Response
     * @throws ApiError
     */
    public static startMfaFlow(
        requestBody: StartMFARequest,
        pendingAuthSession?: (string | null),
        hostDbscSession?: (string | null),
    ): CancelablePromise<any | MfaFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/orchestrator/start',
            cookies: {
                'pending_auth_session': pendingAuthSession,
                '__Host-dbsc_session': hostDbscSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid pending auth session or flow state`,
                401: `Authentication / MFA session expired`,
                403: `User account disabled or flow forbidden`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Choose Authenticator
     * Choose an authenticator for the flow
     * @param requestBody
     * @param mfaSession
     * @returns MfaFlowResponse Successful Response
     * @throws ApiError
     */
    public static chooseAuthenticator(
        requestBody: ChooseAuthenticatorRequest,
        mfaSession?: (string | null),
    ): CancelablePromise<MfaFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/orchestrator/choose-authenticator',
            cookies: {
                'mfa_session': mfaSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Alternative authenticators
     * Get the alternative authenticators for the flow
     * @param mfaSession
     * @returns GetAlternativesResponse Successful Response
     * @throws ApiError
     */
    public static getAlternatives(
        mfaSession?: (string | null),
    ): CancelablePromise<GetAlternativesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mfa/orchestrator/authenticator-alternatives',
            cookies: {
                'mfa_session': mfaSession,
            },
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Resend Availability
     * Get when the current step's next resend is allowed (push / OTP).
     * @param mfaSession
     * @returns ResendAvailability Successful Response
     * @throws ApiError
     */
    public static getResendAvailability(
        mfaSession?: (string | null),
    ): CancelablePromise<ResendAvailability> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mfa/orchestrator/resend-availability',
            cookies: {
                'mfa_session': mfaSession,
            },
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Submit MFA Response
     * Submit response to current MFA challenge
     * @param requestBody
     * @param mfaSession
     * @param mfaAuthenticatedSession
     * @returns any FAILED-without-error_info or COMPLETED (no new step)
     * @returns MfaFlowResponse Successful Response
     * @throws ApiError
     */
    public static submitMfaResponse(
        requestBody: SubmitResponseRequest,
        mfaSession?: (string | null),
        mfaAuthenticatedSession?: (string | null),
    ): CancelablePromise<any | MfaFlowResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mfa/orchestrator/submit',
            cookies: {
                'mfa_session': mfaSession,
                'mfa_authenticated_session': mfaAuthenticatedSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Flow has no alternative method, session has no active step, or factor type unsupported for the requested action`,
                401: `MFA session expired / flow not found`,
                403: `Submit/choose rejected by orchestrator`,
                422: `Validation Error`,
            },
        });
    }
}
